export default __webpack_public_path__ + "static/img-project-7-1f6fa8cde263268b56a6c9f0aae340d9.png";